import { useDispatch } from "react-redux";
import { useState } from "react";
import { IconButton, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

import { TableLayout } from "../../../layout/TableLayout"
import { deleteEventRegisterById } from "../../../helpers/eventRegister";
import { EditEventRegister } from "./EditEventRegister";
import { selectEventRegistered } from "../../../../store/eventRegistered/eventRegisteredSlice";

export const EventRegisteredTable = ({ rows, event, setReloadData }) => {

    const { t } = useTranslation('global');
    const [openEdit, setOpenEdit] = useState(false);
    const dispatch = useDispatch();

    const onEditClick = (e) => {
        dispatch(selectEventRegistered(e.row))
        setOpenEdit(true)
    }
    const onDeleteClick = async ({row}) => {
        await deleteEventRegisterById({...row, name: `${row.individual.name} ${row.individual.surnames}`}, t('delete.successMsg'), t('delete.errorMsg'), t('delete.cancelButton'), t('delete.confirmButton'), t('delete.deleteConfirm'))
        setReloadData(prevState => !prevState)
    }

    const columns = [
        {
            field: 'confirmsAttendance',
            headerName: t('addevent.confirmsAttendance'),
            minWidth: 140,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'individual',
            headerName: t('addevent.partner'),
            minWidth: 220,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (params) => `${params.row.individual.name || ''} ${params.row.individual.surnames || ''}`
        },
        {
            field: 'principalAssistant',
            headerName: t('addevent.principalAssistant'),
            minWidth: 220,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'companions',
            headerName: t('addevent.companionsTable'),
            minWidth: 120,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'comments',
            headerName: t('addevent.comments'),
            minWidth: 500,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'action',
            headerName: t('partnerlist.columnActions'),
            maxWidth: 130,
            align: 'center',
            headerAlign: 'center',
            flex: 0,
            sortable: false,
            renderCell: (params) => {
                return (<Stack direction='row' gap={0}>
                    <IconButton color='secondary' onClick={() => onEditClick(params)}>
                        <EditRoundedIcon />
                    </IconButton>

                    <IconButton color='secondary' onClick={() => onDeleteClick(params)}>
                        <DeleteOutlineRoundedIcon />
                    </IconButton>
                </Stack>
                )
            }
        }
    ]

    return (
        <>
            <TableLayout
                rows={rows}
                columns={columns}
                title='registeredEvent'
                name={event}
            />
            {
                openEdit &&
                <EditEventRegister setHidden={setOpenEdit} setReloadData={setReloadData} />
            }
        </>
    )
}